<template lang="pug">
.modal-confirmacao-assinatura
    .div
        .linha {{ text }}
        label CPF:
        input.input-text(
            type="text"
            v-model="documento"
            maxlength="14"
            @input="formatarDocumento"
            placeholder="___.___.___-__"
        )
        div.documento-invalido(v-if='documentoInvalido') O documento informado é inválido.
        b.linha Após assinar o documento, a ação não poderá ser desfeita. Tem certeza que deseja continuar?
    .linha
        .coluna
            .modal-footer(:style='[ { display: "flex" },  { justifyContent: "space-between" }, { marginTop: "30px" } ]')
                button-component(
                    label='Cancelar',
                    icon='mdi-close',
                    background-color='var(--primary-gray)',
                    color='var(--primary-light-smoke)',
                    @click.native='$emit("cancelar:assinatura")'
                )
                button-component(label='Confirmar', @click.native='validarDocumento')
</template>

<script>
import { isValidCPF } from '@/utils/validators.utils';

export default {

    name: 'ModalConfirmacaoAssinatura',

    props: {
        text: {
            type: String,
            default: null
        }
    },

    data() {
        return {
            documento: '',
            documentoInvalido: false
        }
    },
    methods: {
        formatarDocumento() {
            this.documentoInvalido = false;
            let doc = this.documento.replace(/\D/g, '');
            this.documento = doc.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
        },
        validarDocumento() {
            const documentoInformado = this.documento.replace(/\D/g, '');
            if (!isValidCPF(documentoInformado)) {
                this.documentoInvalido = true;
            } else {
                this.$emit("confirmar:assinatura", documentoInformado)
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.input-text-component {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    width: 100%;
}

.input-text {
    padding: 0px 8px;
    margin: 5px 0 10px 8px;
    height: 26px;
    border: 2px solid var(--primary-light-green) !important;
    border-radius: 5px;
}

.input-text.--error {
    border: 2px solid var(--primary-light-red) !important;
}

.input-text:focus-visible {
    border: 2px solid var(--primary-green) !important;
    border-radius: 5px;
    outline: none;
}

.input-text:focus-visible.--error {
    border: 2px solid var(--primary-red) !important;
}

.documento-invalido {
    margin-left: 40px;
    margin-top: -10px;
    font-size: 12px;
    color: var(--primary-light-red);
}
</style>
